import LoadingContent from "@/components/common/LoadingContent";

export default function CreatingDemo() {
	return (
		<div style={{ height: "100vh", width: "100%", position: "relative" }}>
			<div style={{ position: "absolute", top: "30vh", right: "25%" }}>
				<h1 style={{ paddingBottom: "50vh", textAlign: "center" }}>We're creating your Demo Company...</h1>
				<LoadingContent
					style={{ height: "15vh", width: "15vh" }}
					className="animate-spin"
				/>
			</div>
		</div>
	);
}